/** Formatos e gestos pequenos das telas do orçamento da Manutenção (funções puras fora dos componentes). */
import { api } from '@/lib/api';
import { formatCurrency } from '@/lib/format';

import { orcamentoApi } from './orcamento-api';

export const brl = (centavos: number): string => formatCurrency(centavos / 100);

/**
 * "27/10 às 15:40" no relógio de Brasília. O servidor grava `datetime('now')` (UTC, com espaço) — ⚠️ sem o "Z", `Date`
 * leria como hora local do computador.
 */
export function quando(iso: string | null): string {
  if (!iso) return '';
  const t = Date.parse(/[zZ]|[+-]\d\d:?\d\d$/.test(iso) ? iso : `${iso.replace(' ', 'T')}Z`);
  if (Number.isNaN(t)) return '';
  const d = new Date(t - 3 * 3600_000);
  const dd = String(d.getUTCDate()).padStart(2, '0');
  const mm = String(d.getUTCMonth() + 1).padStart(2, '0');
  const hh = String(d.getUTCHours()).padStart(2, '0');
  const mi = String(d.getUTCMinutes()).padStart(2, '0');
  return `${dd}/${mm} às ${hh}:${mi}`;
}

/** "1,5" ⇄ 1.5 — a quantidade como a pessoa digita. */
export const quantidadeBr = (n: number): string => String(n).replace('.', ',');

/** Abre o PDF do orçamento numa aba nova (o arquivo vem autenticado). */
export async function abrirPdf(id: string): Promise<void> {
  const blob = await api.blob(orcamentoApi.urlDoPdf(id));
  window.open(URL.createObjectURL(blob), '_blank', 'noopener');
}
